(function () {
  'use strict';

  angular.module('eclipseApp.maintenance')

      .factory('maintenanceService', ['$http','$q','uteEndpoint', '$window', function ($http, $q, uteEndpoint, $window) {

        var jsonData = null;
        var deferred = $q.defer();
        var maintenanceService = {
            getMaintenance: function(flowType) {
              if(null != jsonData) {
                 maintenanceService.getFlag(jsonData,flowType);
              }
              else {
                 maintenanceService.setMaintenance().then(function (data){
                    maintenanceService.getFlag(data,flowType);
                 })
              }
            },
            getFlag:function(jsonData,flowType){
              _.forEach(jsonData, function(value,key) {
                  if(value.flowName == flowType){
                     if(value.outageFlag == "true"){
                       window.location.href = value.outageRedirectUri;
                     }
                  }
              });
            },
            setMaintenance: function (){
               $http.get(uteEndpoint('v1/outage/details')).success(function (data) {
                        maintenanceService.setData(data);
                        deferred.resolve(data);
               });
               return deferred.promise;

            },
            setData: function (data){
                jsonData =data;
            }
        };
      return maintenanceService;

      }]);
})();
